import "../src/sass/main.scss"
import "react-toastify/dist/ReactToastify.css"
import {ToastContainer} from "react-toastify"
import AuthListener from "./AuthListener"
import SwrProviderWithAuth from "./SwrProviderWithAuth"
import AllRoutes from "./views/AllRoutes"

export default function App() {
    return (
        <>
        <ToastContainer autoClose={2000}/>
        <AuthListener>
            <SwrProviderWithAuth>
                <AllRoutes/>
            </SwrProviderWithAuth>
        </AuthListener>
        </>
    )
}